import { useState } from 'react';
import {
  Badge,
  Container,
  Group,
  SegmentedControl,
  Stack,
  Tabs,
  Text,
  Title,
} from '@mantine/core';
import { TimelineView } from './components/TimelineView';
import { PlantTable } from './components/PlantTable';
import { CompanionView } from './components/CompanionView';
import { CalendarView } from './components/CalendarView';
import { HarvestChart } from './components/HarvestChart';
import { SettingsView } from './components/SettingsView';
import { usePlantSelection } from './hooks/usePlantSelection';

const TAB_KEY = 'garden-planner-tab';

export function GardenPage() {
  const [filter, setFilter] = useState('all');
  const [activeTab, setActiveTab] = useState(() => localStorage.getItem(TAB_KEY) || 'timeline');
  const selection = usePlantSelection();

  return (
    <Container size="xl" py="md">
      <Stack gap="md">
        <Group justify="space-between" align="flex-end" wrap="wrap">
          <Stack gap={4}>
            <Group gap="sm">
              <Title order={2}>Garden</Title>
              <Badge variant="light" color="green" size="sm">
                Mapleton — Zone 6b
              </Badge>
              <Badge variant="light" color="gray" size="sm">
                ~5,200 ft
              </Badge>
            </Group>
            <Text size="xs" c="dimmed">
              Last frost: May 10 · First frost: Oct 5
            </Text>
          </Stack>
        </Group>

        <Tabs
          value={activeTab}
          onChange={(v) => {
            setActiveTab(v || 'timeline');
            localStorage.setItem(TAB_KEY, v || 'timeline');
          }}
        >
          <Tabs.List mb="md">
            <Tabs.Tab value="timeline">Timeline</Tabs.Tab>
            <Tabs.Tab value="calendar">Calendar</Tabs.Tab>
            <Tabs.Tab value="harvest">Space &amp; Harvest</Tabs.Tab>
            <Tabs.Tab value="table">Plant Details</Tabs.Tab>
            <Tabs.Tab value="companions">Companions</Tabs.Tab>
            <Tabs.Tab value="settings">My Garden ({selection.selectedCount})</Tabs.Tab>
          </Tabs.List>

          <Group mb="md">
            <Text size="sm" fw={500}>
              Filter:
            </Text>
            <SegmentedControl
              size="xs"
              value={filter}
              onChange={setFilter}
              data={[
                { label: 'All', value: 'all' },
                { label: 'Vegetables', value: 'vegetable' },
                { label: 'Herbs', value: 'herb' },
                { label: 'Fruit', value: 'fruit' },
                { label: 'Flowers', value: 'flower' },
              ]}
            />
          </Group>

          <Tabs.Panel value="timeline">
            <TimelineView filter={filter} isSelected={selection.isSelected} />
          </Tabs.Panel>
          <Tabs.Panel value="calendar">
            <CalendarView isSelected={selection.isSelected} />
          </Tabs.Panel>
          <Tabs.Panel value="harvest">
            <HarvestChart isSelected={selection.isSelected} />
          </Tabs.Panel>
          <Tabs.Panel value="table">
            <PlantTable filter={filter} isSelected={selection.isSelected} />
          </Tabs.Panel>
          <Tabs.Panel value="companions">
            <CompanionView isSelected={selection.isSelected} />
          </Tabs.Panel>
          <Tabs.Panel value="settings">
            <SettingsView
              isSelected={selection.isSelected}
              toggle={selection.toggle}
              selectAll={selection.selectAll}
              selectNone={selection.selectNone}
              selectCategory={selection.selectCategory}
              selectedCount={selection.selectedCount}
            />
          </Tabs.Panel>
        </Tabs>
      </Stack>
    </Container>
  );
}
